import React, { Component, Fragment } from "react";
import ReactDOM from "react-dom";
import TinyDatePicker from "tiny-date-picker";
import Attachments from "./Attachments";
import CostEstimateRows from "./CostEstimateRows";
import CostEstimateSpread from "./CostEstimateSpread";
import CostEstimateValue from "./CostEstimateValue";
import CustomerWithContactForm from "./CustomerWithContactForm";
import FileSearch from "./FileSearch";
import LogTable from "./LogTable";
import Popup from "reactjs-popup";
import DefaultPopup from "./common/defaultPopup";
import Progress from "./common/progress";
import getArticles from "../services/articlesService";
import {
    getAllFiles,
    getCostEstimateAttachments
} from "../services/filesService";
import costEstimatesService from "../services/costEstimatesService";
import costEstimateRowsService, {
    CostEstimateRowsCalculator
} from "../services/costEstimateRowsService";
import { getContactsForCustomer, saveCustomerInfo, saveProductionInfo } from "../services/customersService";
import logService from "../services/logsService";
import CustomerUploadedFiles from "./CustomerUploadedFiles";

const uuidv4 = require("uuid/v4");

window.addEventListener("cost-estimate:load", () => {
    const actionButtons = document.querySelectorAll(".actionButtons button");
    if (actionButtons.length) {
        actionButtons.forEach(node => {
            // if(node.name == 'createDelivery') return;
            node.removeAttribute("disabled");
        });
    }
});

let warningShownFor = [];

window.addEventListener("cost-estimate:warnAutoCalculateFunctionNotFound", (arg) => {
    if (document.location.href.indexOf('edit') == -1) return;
    if (warningShownFor.indexOf(arg.detail) > -1) return;

    var $cell = jQuery('.nestable-item-' + arg.detail + ' .listCell:nth-child(3)');
    $cell.popover(
        {
            content: 'Antalet kunde inte beräknas automatiskt',
            placement: 'top'
        }
    );

    $cell.popover('show');
    setTimeout(() => { $cell.popover('hide'), warningShownFor.push(arg.detail); }, 5000);
});

class CostEstimate extends Component {
    logHeadings = ["Status", "Datum", "Tid", "Antal", "Utförd av"];

    handleAddCostEstimateRow = async row => {
        const { data } = await costEstimateRowsService.getRowAttributes(row);
        const { customer } = this.state;
        let { customerInfo, productionInfo } = this.state;

        data.originalArticle = { ...data };
        data.id = this.generateKey();
        data.number = data.id;
        data.showInfoBoard = this.props.isEditable;
        data.customer = customer;
        data.quantity = 0;

        if (data.customer_info != null && data.customer_info != "") {
            customerInfo += "\n" + data.customer_info;
        }

        if (data.production_info != null && data.production_info != "") {
            productionInfo += "\n" + data.production_info;
        }

        let costEstimateRows = [...this.state.costEstimateRows, data];

        this.setState(
            { costEstimateRows, customerInfo, productionInfo },
            () => {
                this.recalculate(costEstimateRows);
            }
        );
    };

    handleDeleteCostEstimateRow = (row, event) => {
        event.preventDefault();
        const { costEstimateRows } = this.state;

        let index;
        index = costEstimateRows.findIndex(r => r.id === row.id);

        if (index === -1) {
            // Nothing found so we need to look through any children
            for (let r of costEstimateRows) {
                if (r.children.length > 0) {
                    index = r.children.findIndex(r => r.id === row.id);
                    if (index > -1) {
                        r.children.splice(index, 1);
                        break;
                    }
                }
            }
        } else {
            const children = costEstimateRows[index].children;
            if (children.length > 0) {
                children.forEach(r => {
                    const childRow = { ...r };
                    childRow.parentIndex = null;
                    costEstimateRows.push(childRow);
                });
            }
            costEstimateRows.splice(index, 1);
        }

        this.setState(
            {
                costEstimateRows
            },
            () => {
                this.recalculate(this.state.costEstimateRows);
            }
        );
    };

    handleChangeCostEstimateRow = (id, key, value, changeSource) => {
        const costEstimateRows = [...this.state.costEstimateRows];
        let index;
        let updateState = false;

        index = costEstimateRows.findIndex(r => r.id === id);

        if (index === -1) {
            // Nothing found so we need to look through any children
            costEstimateRows.map(r => {
                if (r.children.length > 0) {
                    index = r.children.findIndex(r => r.id === id);
                    if (index > -1) {
                        if (r.children[index][key] !== value) {
                            r.children[index][key] = value;
                            updateState = true;
                        }
                    }
                }
            });
        } else {
            if (costEstimateRows[index][key] !== value) {
                costEstimateRows[index][key] = value;
                updateState = true;

                if (
                    changeSource == "row_outside_of_infoboard" &&
                    key == "quantity"
                ) {
                    // This prevents infoboard auto calculation value to update quantity when item is dropped
                    costEstimateRows[index]["dont_recalculate_quantity"] =
                        value > 0 ? 1 : 0;
                }
            }
        }

        if (key == "clear_dont_recalculate_flag") {
            costEstimateRows[index].children.map(c => {
                c["dont_recalculate_quantity"] = 0;
            });
        }

        if (updateState) {
            this.setState(
                {
                    costEstimateRows
                },
                () => {
                    this.recalculate(this.state.costEstimateRows);
                }
            );
        }
    };

    recalculate = costEstimateRows => {
        // Create a fake props object with the least required variables for CostEstimateRowsCalculator
        let fakeProps = {
            rows: costEstimateRows,
            multiplier: 1
        };

        const totalCost = CostEstimateRowsCalculator.getTotalProductionCost(
            fakeProps
        );
        const totalExtraCost = CostEstimateRowsCalculator.getTotalExtraCost(
            fakeProps
        );
        const totalTime = CostEstimateRowsCalculator.getTotalTime(fakeProps);
        const totalPurchasePrice = CostEstimateRowsCalculator.getTotalPurchasePrice(
            fakeProps
        );
        const totalWeight = CostEstimateRowsCalculator.getTotalWeight(
            fakeProps
        );
        const totalMargin = CostEstimateRowsCalculator.getTotalMargin(
            fakeProps
        );
        const totalPrice = CostEstimateRowsCalculator.getTotalPrice(fakeProps);
        const totalDiscount = CostEstimateRowsCalculator.getTotalDiscount(
            fakeProps
        );
        const totalPriceAfterDiscount = CostEstimateRowsCalculator.getTotalPriceAfterDiscount(
            fakeProps
        );

        this.setState({
            totalCost,
            totalExtraCost,
            totalTime,
            totalPurchasePrice,
            totalWeight,
            totalMargin,
            totalPrice,
            totalDiscount,
            totalPriceAfterDiscount
        });
    };

    handleNameInputChange = event => {
        const name = event.target.value;
        this.setState({
            name
        });
    };

    handleCreatedDateInputChange = event => {
        const createdDate = event.target.value;
        this.setState({
            createdDate
        });
    };

    handleQuantityInputChange = event => {
        let quantity = Number.parseInt(event.target.value);
        if (Number.isNaN(quantity) || quantity < 1) {
            quantity = "-";
        }
        this.setState({
            quantity
        });
    };

    handleCustomerInfoInputChange = event => {
        const customerInfo = event.target.value;

        this.setState({
            customerInfo
        });
    };

    cancelEditCustomerInfo = () => {
        this.setState({ customerInfo: this.props.customerInfo, editCustomerInfo: false });
    }

    fetchCustomerInfoFromArticles = async () => {
        const response = await costEstimatesService.fetchCustomerInfoFromArticles(
            this.props.id
        );
        if (response.status == 200) {
            if (response.data == '') {
                alert('Artiklarna har inga texter');
                return;
            }
            this.setState({ customerInfo: response.data });
        } else {
            alert('Kunde inte ladda information från artiklar');
        }
    }

    saveCustomerInfo = () => {
        saveCustomerInfo(this.props.id, this.state.customerInfo);
        this.setState({ editCustomerInfo: false });
    }

    handleProductionInfoInputChange = event => {
        const productionInfo = event.target.value;
        this.setState({
            productionInfo
        });
    };

    cancelEditProductionInfo = () => {
        this.setState({ productionInfo: this.props.productionInfo, editProductionInfo: false });
    }

    fetchProductionInfoFromArticles = async () => {
        const response = await costEstimatesService.fetchProductionInfoFromArticles(
            this.props.id
        );
        if (response.status == 200) {
            if (response.data == '') {
                alert('Artiklarna har inga texter');
                return;
            }
            this.setState({ productionInfo: response.data });
        } else {
            alert('Kunde inte ladda information från artiklar');
        }
    }

    saveProductionInfo = () => {
        saveProductionInfo(this.props.id, this.state.productionInfo);
        this.setState({ editProductionInfo: false });
    }

    handleSpreadRowQuantityChange = (index, event) => {
        const quantities = [...this.state.quantities];
        let quantity = Number.parseInt(event.target.value);

        if (Number.isNaN(quantity)) {
            quantity = "";
        }

        quantities[index] = quantity;
        this.setState({
            quantities,
            selectedInterval: ""
        });
    };

    handleSpreadIntervalUpdate = (interval, selectedInterval) => {
        this.setState({
            selectedInterval,
            quantities: interval
        });
    };

    /**
     *
     * @param event
     * @param attachment
     */
    handleRemoveAttachment = (event, attachment) => {
        event.preventDefault();
        const originalAttachments = this.state.attachments;
        const attachments = originalAttachments.filter(
            a => a.id !== attachment.id
        );

        this.setState({
            attachments
        });
    };

    handleCreateFromTemplate = async event => {
        event.preventDefault();
        const templateId = this.templateSelectField.current.value;
        if (templateId) {
            const response = await costEstimatesService.createNewFromTemplate(
                templateId
            );
            const { id, url } = response.data;
            this.setState({
                openTemplatePopup: false
            });
            if (id) {
                window.location.assign(url);
            }
        }
    };

    handleOpenFilesPopup = event => {
        event.preventDefault();

        this.setState({
            openFilesPopup: true
        });
    };

    handleCloseFilesPopup = () => {
        this.setState({
            openFilesPopup: false
        });
    };

    handleOpenNewTemplatePopup = () => {
        this.setState({
            openNewTemplatePopup: true
        });
    };

    handleCloseNewTemplatePopup = () => {
        this.setState({
            openNewTemplatePopup: false
        });
    };

    handleOpenTemplatePopup = () => {
        this.setState({
            openTemplatePopup: true
        });
    };

    handleCloseTemplatePopup = () => {
        this.templateSelectField.current.selectedIndex = 0;
        this.setState({
            openTemplatePopup: false
        });
    };

    handleAttachFile = (event, file) => {
        event.preventDefault();
        const attachments = [...this.state.attachments, file];

        this.setState({
            attachments,
            openFilesPopup: false
        });
    };

    handleCustomerSelect = async customer => {
        // Load any existing contacts for the selected customer
        const { data } = await getContactsForCustomer(customer.id);
        const contacts = Array.prototype.map.call(data, contact => {
            return {
                _id: contact.id,
                id: contact.id,
                name: contact.firstname + " " + contact.lastname,
                firstname: contact.firstname,
                lastname: contact.lastname
            };
        });

        const contact = null;

        window.costEstimate.data.customer = customer;

        this.setState(
            {
                contact,
                contacts,
                customer
            },
            () => {
                this.recalculate(this.state.costEstimateRows);
            }
        );
    };

    handleCustomerContactSelect = contact => {
        this.setState({
            contact
        });
    };

    handleCostEstimateRowsSortEnd = costEstimateRows => {
        this.setState(
            {
                costEstimateRows
            },
            () => {
                this.recalculate(this.state.costEstimateRows);
            }
        );
    };

    handleTemplateSelect = event => {
        const templateId = this.templateSelectField.current.value;
        if (templateId) {
            this.setState({
                openTemplatePopup: true
            });
        }
    };

    editCustomerInfo = () => {
        this.setState({ editCustomerInfo: true });
    };

    editProductionInfo = () => {
        this.setState({ editProductionInfo: true });
    };

    generateKey = () => {
        return uuidv4();
    };

    constructor(props) {
        super(props);
        this.id = props.id;
        this.state = {
            articles: [],
            attachments: [],
            costEstimateRows: [],
            contact: props.contact,
            contacts: [],
            createdDate: props.createdDate,
            customer: props.customer,
            customerInfo: props.customerInfo,
            files: [],
            logRows: [],
            logRowsFull: [],
            name: props.name,
            openFilesPopup: false,
            openNewTemplatePopup: false,
            openTemplatePopup: false,
            productionInfo: props.productionInfo,
            selectedInterval: props.selectedInterval,
            quantities: props.quantities,
            quantity: props.quantity,
            totalCost: 0.0,
            totalExtraCost: 0.0,
            totalTime: "00:00:00",
            totalPurchasePrice: "0.0",
            totalWeight: 0,
            totalMargin: 0,
            totalPrice: 0,
            totalDiscount: 0,
            totalPriceAfterDiscount: 0,
            template: 0,
            templateGroupId: 0,
            validationErrors: {}
        };

        this.handleAddCostEstimateRow = this.handleAddCostEstimateRow.bind(
            this
        );
        this.handleDeleteCostEstimateRow = this.handleDeleteCostEstimateRow.bind(
            this
        );
        this.handleChangeCostEstimateRow = this.handleChangeCostEstimateRow.bind(
            this
        );

        this.createdDateInput = React.createRef();
        this.templateSelectField = React.createRef();
    }

    async componentDidMount() {
        window.addEventListener("cost-estimate:validationError", event => {
            const { errorField, errorMessage } = event.detail;
            let { validationErrors } = this.state;

            if (errorField) {
                if (errorField === "customer_id") {
                    validationErrors.customer = {
                        message: errorMessage
                    };
                }
            } else {
                validationErrors = {};
            }

            this.setState({
                validationErrors
            });
        });

        window.addEventListener(
            "cost-estimate:saveAsTemplateDialogue",
            event => {
                event.preventDefault();
                this.setState({
                    saveAsTemplateDialogue: true
                });
            }
        );

        window.addEventListener("cost-estimate:saveAsTemplate", event => {
            event.preventDefault();
            this.setState(
                {
                    name: event.detail.name,
                    template: 1,
                    templateGroupId: event.detail.templateGroupId,
                    saveAsTemplateDialogue: false
                },
                () => {
                    let editableForm = document.forms["costEstimateCreateForm"]
                        ? document.forms["costEstimateCreateForm"]
                        : document.forms["costEstimateEditForm"];

                    if (editableForm) {
                        editableForm.submit();
                    } else {
                        const { id } = this.props;
                        const { name, templateGroupId } = this.state;

                        document.location =
                            "/cost-estimates/" +
                            id +
                            "/createTemplateFromCostEstimate/" +
                            templateGroupId +
                            "/" +
                            name;
                    }
                }
            );
        });

        if (this.id) {
            this.setState({
                progressLabel: "Hämtar artikelrader",
                progressPercent: 20
            });

            // Load any existing CostEstimateRows
            const {
                data: costEstimateRows
            } = await costEstimateRowsService.getRows(this.id);

            costEstimateRows.map(row => {
                row.originalArticle = { ...row };
                row._id = row.id;
                row.id = this.generateKey();
                row.number = row.id;
                row.showInfoBoard = this.props.isEditable;

                row.children.map(childRow => {
                    childRow.originalArticle = { ...childRow };
                    childRow._id = childRow.id;
                    childRow.id = this.generateKey();
                    childRow.number = childRow.id;
                });
            });

            this.setState(
                {
                    costEstimateRows,
                    progressLabel: "Hämtar bifogade filer",
                    progressPercent: 40
                },
                () => {
                    this.recalculate(costEstimateRows);
                }
            );

            // Load any existing attachments
            const { data: attachments } = await getCostEstimateAttachments(
                this.id
            );
            this.setState({
                attachments
            });
        }

        if (this.props.isEditable) {
            this.setState({
                progressLabel: "Hämtar artiklar och filer",
                progressPercent: 50
            });

            // Load Articles for the autocomplete list
            const { data: articles } = await getArticles();

            this.setState({
                articles
            });

            // Load Files for the file search dialog
            const { data: files } = await getAllFiles();

            this.setState({
                files
            });

            let contacts = [];

            if (this.state.customer) {
                this.setState({
                    progressLabel: "Hämtar kontakter",
                    progressPercent: 60
                });

                // Load any existing contacts for the selected customer
                const { data } = await getContactsForCustomer(
                    this.state.customer.id
                );
                contacts = Array.prototype.map.call(data, contact => {
                    return {
                        _id: contact.id,
                        id: contact.id,
                        name: contact.firstname + " " + contact.lastname,
                        firstname: contact.firstname,
                        lastname: contact.lastname
                    };
                });
            }

            this.setState({
                contacts
            });
        }
        if (this.id) {
            // Dispatch a global event
            const event = new Event("cost-estimate:load");
            window.dispatchEvent(event);

            this.setState({
                progressLabel: "Hämtar historik",
                progressPercent: 90
            });

            // Load any existing logs
            const { data: logRows } = await logService.getCostEstimateLogs(
                this.id,
                1
            );
            const { data: logRowsFull } = await logService.getCostEstimateLogs(
                this.id,
                0
            );

            this.setState({
                logRows, logRowsFull
            });
        }

        this.setState(
            {
                progressLabel: "Klar!",
                progressPercent: 100
            },
            () => {
                setTimeout(() => {
                    this.setState({
                        progressLabel: ""
                    });
                }, 1000);
            }
        );

        if (this.createdDateInput.current) {
            // Initiate a datepicker
            TinyDatePicker(this.createdDateInput.current, {
                dayOffset: 1,
                format(date) {
                    return date.toLocaleDateString();
                },
                lang: {
                    days: ["Sön", "Mån", "Tis", "Ons", "Tor", "Fre", "Lör"],
                    months: [
                        "Januari",
                        "Februari",
                        "Mars",
                        "April",
                        "Maj",
                        "Juni",
                        "Juli",
                        "Augusti",
                        "September",
                        "Oktober",
                        "November",
                        "December"
                    ],
                    today: "Idag",
                    clear: "Rensa",
                    close: "Stäng"
                }
            }).on("select", (eventName, dp) => {
                this.setState({
                    createdDate: dp.state.selectedDate
                        ? dp.state.selectedDate.toLocaleDateString()
                        : ""
                });
            });
        }
    }

    handleClosedPopup = name => {
        this.setState({
            [name]: false
        });
    };

    render() {
        const { id, costEstimateNumber, isEditable, editingCopy, customerUploadedFiles } = this.props;
        const {
            articles,
            attachments,
            createdDate,
            contact,
            contacts,
            costEstimateRows,
            customer,
            customerInfo,
            files,
            logRows,
            logRowsFull,
            name,
            openFilesPopup,
            productionInfo,
            quantities,
            validationErrors,
            saveAsTemplateDialogue,
            selectedInterval,
            template,
            templateGroupId,
            totalCost,
            totalExtraCost,
            totalTime,
            totalPurchasePrice,
            totalWeight,
            totalMargin,
            totalPrice,
            totalDiscount,
            totalPriceAfterDiscount,
            editCustomerInfo,
            editProductionInfo
        } = this.state;

        let customerNote = "";
        if (this.state.customer) {
            customerNote = this.state.customer.note;
        }

        let { quantity } = this.state;

        if (quantity == 0) quantity = "";

        const { progressLabel, progressPercent } = this.state;
        const attachmentIds = attachments.map(attachment => attachment.id);
        const filteredFiles = files.filter(
            file =>
                attachments.filter(attachment => attachment.id === file.id)
                    .length === 0
        );

        return (
            <Fragment>
                {progressLabel && (
                    <div className="row">
                        <div className="col pb-4">
                            <Progress
                                label={progressLabel}
                                progress={progressPercent}
                            />
                        </div>
                    </div>
                )}

                <div className="row blueBox">
                    <div className="col-sm-12">
                        <div className="row">
                            <div className="col-sm-2 col-lg-1">
                                <div className="form-group">
                                    <label>Kalkylnr.</label>
                                    <div className="form-control">
                                        {costEstimateNumber}
                                    </div>
                                </div>
                            </div>
                            {id && (
                                <input
                                    type="hidden"
                                    name="id"
                                    readOnly
                                    value={costEstimateNumber}
                                />
                            )}
                            <input
                                type="hidden"
                                name="template"
                                readOnly
                                value={template}
                            />
                            <input
                                type="hidden"
                                name="template_group_id"
                                readOnly
                                value={templateGroupId}
                            />
                            {isEditable && (
                                <div className="col-sm-3 pl-0">
                                    <div className="form-group">
                                        <label>Benämning</label>
                                        <input
                                            className="form-control"
                                            name="name"
                                            onChange={event =>
                                                this.handleNameInputChange(
                                                    event
                                                )
                                            }
                                            required
                                            value={name}
                                        />
                                    </div>
                                </div>
                            )}
                            {!isEditable && (
                                <div className="col-sm-3 pl-0">
                                    <label>Benämning</label>
                                    <div className="form-control">{name}</div>
                                </div>
                            )}
                            <div className="col-sm-3 col-lg-2 pl-0">
                                <div className="form-group">
                                    <label>Skapad</label>
                                    {isEditable && (
                                        <input
                                            className="form-control"
                                            name="created_date"
                                            onChange={event =>
                                                this.handleCreatedDateInputChange(
                                                    event
                                                )
                                            }
                                            required
                                            ref={this.createdDateInput}
                                            value={createdDate}
                                        />
                                    )}
                                    {!isEditable && (
                                        <div className="form-control">
                                            {createdDate}
                                        </div>
                                    )}
                                </div>
                            </div>
                            {attachments && (
                                <div className="col-sm-4 col-lg-3 pl-0">
                                    <div className="form-group">
                                        <label>Medföljande filer</label>
                                        <div className="form-group row">
                                            <Fragment>
                                                <div
                                                    className={
                                                        isEditable
                                                            ? "col-9"
                                                            : "col-12"
                                                    }
                                                >
                                                    <div className="form-control form-control-sm form-control-attachments">
                                                        <Attachments
                                                            attachments={
                                                                attachments
                                                            }
                                                            isEditable={
                                                                isEditable
                                                            }
                                                            removeAttachment={
                                                                this
                                                                    .handleRemoveAttachment
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                                {isEditable && (
                                                    <div className="col-3 pl-0">
                                                        <input
                                                            type="hidden"
                                                            name="attachments"
                                                            value={
                                                                attachmentIds
                                                            }
                                                        />
                                                        <button
                                                            className="btn btn-icon btn-icon--search"
                                                            onClick={event =>
                                                                this.handleOpenFilesPopup(
                                                                    event
                                                                )
                                                            }
                                                        >
                                                            Sök
                                                        </button>
                                                        <DefaultPopup
                                                            onClosePopup={() =>
                                                                this.handleCloseFilesPopup()
                                                            }
                                                            openPopup={
                                                                openFilesPopup
                                                            }
                                                            title="Sök bland filer"
                                                            contentClassName="content"
                                                        >
                                                            <FileSearch
                                                                files={
                                                                    filteredFiles
                                                                }
                                                                onAttachFile={
                                                                    this
                                                                        .handleAttachFile
                                                                }
                                                            />
                                                        </DefaultPopup>
                                                    </div>
                                                )}
                                            </Fragment>
                                        </div>
                                    </div>
                                </div>
                            )}
                            {(customerUploadedFiles &&
                                <div className="col-sm-12 col-lg-3 pl-lg-0">
                                    <div className="form-group">
                                        <label>Filer från kund</label>
                                        <div className="form-group row">
                                            <Fragment>
                                                <div className="col-sm-12">
                                                    <div className="form-control form-control-sm form-control-attachments">
                                                        <CustomerUploadedFiles
                                                            files={
                                                                customerUploadedFiles
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            </Fragment>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                        <div className="row">
                            <CustomerWithContactForm
                                isEditable={isEditable}
                                contact={contact}
                                contacts={contacts}
                                customer={customer}
                                costEstimateId={id}
                                editingCopy={editingCopy}
                                error={validationErrors.customer}
                                onContactSelect={
                                    this.handleCustomerContactSelect
                                }
                                onCustomerSelect={this.handleCustomerSelect}
                            />

                            <div className="col-sm-4 col-lg-6 pl-0">
                                <div className="form-group">
                                    <label>Information om kunden</label>
                                    <div className="form-control newlineToBr limitHeight">
                                        {customerNote}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row mb-3">
                    <div className="col-12 pl-0 pr-0">
                        <CostEstimateRows
                            articles={articles}
                            isEditable={isEditable}
                            onAddRow={this.handleAddCostEstimateRow}
                            onChangeRow={this.handleChangeCostEstimateRow}
                            onDeleteRow={this.handleDeleteCostEstimateRow}
                            onRowsSortEnd={this.handleCostEstimateRowsSortEnd}
                            rows={costEstimateRows}
                            totalCost={totalCost}
                            totalExtraCost={totalExtraCost}
                            totalTime={totalTime}
                            totalPurchasePrice={totalPurchasePrice}
                            totalWeight={totalWeight}
                            totalMargin={totalMargin + "%"}
                            totalPrice={totalPrice}
                            totalDiscount={totalDiscount + "%"}
                            totalPriceAfterDiscount={totalPriceAfterDiscount}
                            customer={customer}
                            articleGroupsForSearchFunction={
                                this.props.articleGroupsForSearchFunction
                            }
                            globalSettings={this.props.globalSettings}
                        />
                    </div>
                </div>
                <div className="row">
                    <div className="col-4">
                        <div className="row mb-2 mr-0 pb-3 blueBox">
                            <div className="col-sm-12">
                                <label>Info till kunden</label>
                                {isEditable && (
                                    <textarea
                                        className="form-control mb-2"
                                        name="customer_info"
                                        onChange={event =>
                                            this.handleCustomerInfoInputChange(
                                                event
                                            )
                                        }
                                        value={customerInfo}
                                    />
                                )}
                                {!isEditable && editCustomerInfo && (
                                    <Fragment>
                                        <textarea
                                            className="form-control mb-2"
                                            name="customer_info"
                                            value={customerInfo}
                                            onChange={event => this.handleCustomerInfoInputChange(event)}
                                        />
                                        <div className="text-right">
                                            <a
                                                onClick={event => this.cancelEditCustomerInfo(event)}
                                                className="btn btn-icon btn-icon--cancel mr-2" >Avbryt</a>
                                            <a
                                                onClick={event => this.fetchCustomerInfoFromArticles(event)}
                                                className="btn btn-icon btn-icon--refresh mr-2" >Uppdatera från artiklar</a>
                                            <a
                                                onClick={event => this.saveCustomerInfo(event)}
                                                className="btn btn-icon btn-icon--save" >Spara</a>
                                        </div>
                                    </Fragment>
                                )}
                                {!isEditable && !editCustomerInfo && (
                                    <div className="form-control mb-2 pr-4 newlineToBr">
                                        {customerInfo}
                                        <a
                                            onClick={event => this.editCustomerInfo(event)}
                                            className="btn btn-icon--editInverted" />
                                    </div>
                                )}
                            </div>
                            <div className="col-sm-12">
                                <label>Info till produktion</label>
                                {isEditable && (
                                    <textarea
                                        className="form-control"
                                        name="production_info"
                                        onChange={event =>
                                            this.handleProductionInfoInputChange(
                                                event
                                            )
                                        }
                                        value={productionInfo}
                                    />
                                )}
                                {!isEditable && editProductionInfo && (
                                    <Fragment>
                                        <textarea
                                            className="form-control mb-2"
                                            name="production_info"
                                            value={productionInfo}
                                            onChange={event => this.handleProductionInfoInputChange(event)}
                                        />
                                        <div className="text-right">
                                            <a
                                                onClick={event => this.cancelEditProductionInfo(event)}
                                                className="btn btn-icon btn-icon--cancel mr-2" >Avbryt</a>
                                            <a
                                                onClick={event => this.fetchProductionInfoFromArticles(event)}
                                                className="btn btn-icon btn-icon--refresh mr-2" >Uppdatera från artiklar</a>
                                            <a
                                                onClick={event => this.saveProductionInfo(event)}
                                                className="btn btn-icon btn-icon--save" >Spara</a>
                                        </div>
                                    </Fragment>
                                )}
                                {!isEditable && !editProductionInfo && (
                                    <div className="form-control mb-2 pr-4 newlineToBr">
                                        {productionInfo}
                                        <a
                                            onClick={event => this.editProductionInfo(event)}
                                            className="btn btn-icon--editInverted" />
                                    </div>
                                )}
                            </div>
                        </div>
                        {logRows.length > 0 && (
                            <div className="row mt-3 mr-0">
                                <div className="col pl-0 pr-0">
                                    <LogTable
                                        headings={this.logHeadings}
                                        data={
                                            logRows.length > 5
                                                ? logRows.slice(0, 5)
                                                : logRows
                                        }
                                    />
                                    {logRows.length > 0 && (
                                        <DefaultPopup
                                            title="Samtliga händelser"
                                            trigger={
                                                <a className="pointerOnHover">
                                                    Visa samtliga händelser
                                                </a>
                                            }
                                            popupStyle={{ maxHeight: '780px', overflow: 'auto' }}
                                        >
                                            <LogTable
                                                headings={this.logHeadings}
                                                data={logRowsFull}
                                            />
                                        </DefaultPopup>
                                    )}
                                </div>
                            </div>
                        )}
                    </div>
                    <div className="col">
                        <div className="row blueBox">
                            <div className="col pr-0">
                                {
                                    <Fragment>
                                        <input
                                            type="hidden"
                                            name="quantities"
                                            readOnly
                                            value={quantities}
                                        />
                                        <CostEstimateValue
                                            isEditable={isEditable}
                                            quantity={quantity}
                                            rows={costEstimateRows}
                                            customer={customer}
                                            globalSettings={
                                                this.props.globalSettings
                                            }
                                        />
                                        <CostEstimateSpread
                                            isEditable={isEditable}
                                            onIntervalUpdate={
                                                this.handleSpreadIntervalUpdate
                                            }
                                            onQuantityChange={
                                                this
                                                    .handleSpreadRowQuantityChange
                                            }
                                            handleQuantityInputChange={
                                                this.handleQuantityInputChange
                                            }
                                            selectedInterval={selectedInterval}
                                            quantities={quantities}
                                            quantity={quantity}
                                            rows={costEstimateRows}
                                            customer={customer}
                                            globalSettings={
                                                this.props.globalSettings
                                            }
                                        />
                                    </Fragment>
                                }
                            </div>
                        </div>
                    </div>
                </div>
                <Popup
                    closeOnDocumentClick
                    contentStyle={{
                        background: "transparent none",
                        border: "none",
                        borderRadius: "4px",
                        padding: "0",
                        width: "400px"
                    }}
                    modal
                    onClose={() =>
                        this.handleClosedPopup("saveAsTemplateDialogue")
                    }
                    open={saveAsTemplateDialogue}
                    position="top left"
                >
                    {close => (
                        <div className="wrapper">
                            <header className="header py-2">
                                <a className="close" onClick={close}>
                                    &times;
                                </a>
                                Spara som mall
                            </header>
                            <div className="content p-0">
                                <div className="responsiveIframe">
                                    <iframe
                                        className=""
                                        height="400"
                                        src={
                                            "/cost-estimates/saveAsTemplateDialogue/" +
                                            name
                                        }
                                        frameBorder="0"
                                        width="100%"
                                    />
                                </div>
                            </div>
                        </div>
                    )}
                </Popup>
            </Fragment>
        );
    }
}

if (window.costEstimate) {
    const ce = window.costEstimate;

    ReactDOM.render(
        <CostEstimate
            contact={ce.data.contact}
            createdDate={ce.data.createdDate}
            customer={ce.data.customer}
            customerInfo={ce.data.customerInfo}
            id={ce.data.id || ""}
            costEstimateNumber={ce.data.costEstimateNumber || ""}
            isEditable={ce.settings.makeEditable}
            editingCopy={ce.settings.editingCopy}
            customerUploadedFiles={ce.data.customerUploadedFiles}
            name={ce.data.name}
            productionInfo={ce.data.productionInfo}
            selectedInterval={ce.data.selectedInterval}
            quantities={ce.data.quantities}
            quantity={ce.data.quantity}
            globalSettings={ce.data.globalSettings}
            articleGroupsForSearchFunction={
                ce.data.articleGroupsForSearchFunction
            }
        />,
        ce.settings.target
    );
}